<template>
  <div class="ng-applicant-dialog">
    <el-dialog :visible.sync="visible" title="NGアカウントの追加" custom-class="with-title" :before-close="beforeClose">
      <div v-loading="loading">
        <div class="message message-info mb-x2">
          <div>NGアカウントとしたいアカウントの@ではじまるユーザー名を入力してください。</div>
          <div>NGアカウントからの応募は無効となります。</div>
          <div>複数入力する場合、1アカウント1行となるよう改行してください。</div>
        </div>
        <!-- テンプレート名-->
        <div class="input-container">
          <div class="label mb-x1">ユーザー名入力</div>
          <div class="input">
            <el-input
              class="body-textarea"
              :placeholder="displayText + 'ユーザー名を入力'"
              :class="{ success: $v.screenNames.required && !$v.screenNames.$invalid && screenNames.trim() }"
              type="textarea"
              v-model="screenNames"
              tabindex="1"
              @blur="$v.screenNames.$touch"
            ></el-input>
          </div>
          <div class="input-invalid-text" v-if="!$v.screenNames.required && $v.screenNames.$error">
            {{ displayText + 'ユーザー名を入力してください。' }}
          </div>
          <div class="input-invalid-text" v-else-if="maxNgApplicantError">
            一度にインポートできる件数（10,000件）を超えています。
          </div>
        </div>
        <div class="dialog-footer">
          <el-button type="primary" :disabled="disabled" @click="addNgApplicants"
            ><i class="mdi mdi-plus"></i>追加</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss">
.body-textarea {
  textarea {
    height: 260px;
  }
}
</style>
<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'
import { required } from 'vuelidate/lib/validators'

import api from '@/client/core/api'
import { useSettingGroupStore } from '@/client/store/useSettingGroupStore'
import { useSystemStore } from '@/client/store/useSystemStore'

export default defineComponent({
  data() {
    return {
      snsType: 'twitter',
      visible: false,
      loading: false,
      screenNames: '',
      isSaving: false
    }
  },
  computed: {
    ...mapState(useSystemStore, {
      currentGroup: state => state.currentGroup
    }),
    isFormValid() {
      if (this.screenNames.trim()) {
        return true
      }

      return false
    },
    isFormChanged() {
      return this.screenNames !== ''
    },
    displayText() {
      if (this.snsType === 'instagram') {
        return 'Instagram'
      }

      if (this.snsType === 'tiktok') {
        return 'TikTok'
      }

      return 'X(Twitter)'
    },
    maxNgApplicantError() {
      if (!this.screenNames.trim()) {
        return false
      }

      return this.screenNames.trim().split('\n').length > 10000
    },
    disabled() {
      return !this.isFormValid || this.maxNgApplicantError || this.isSaving
    }
  },
  methods: {
    ...mapActions(useSettingGroupStore, ['fetchNgApplicants']),
    /**
     * Open dialog
     */
    async open(snsType: string) {
      this.snsType = snsType
      this.$v.$reset()
      this.visible = true
    },

    /**
     * NGアカウントの新規作成
     */
    async addNgApplicants() {
      if (!this.isFormValid) {
        return
      }

      this.isSaving = true
      const params = this.setParams()

      const result = await api.post(`/${this.snsType}_ng_applicants`, params)

      setTimeout(() => {
        this.isSaving = false
      }, 2000)

      if (!result.data) {
        this.$notify({
          title: 'NGアカウントの追加に失敗しました。',
          message: '恐れ入りますが、時間をおいて再度お試しください。',
          customClass: 'danger',
          duration: 5000
        })
        this.reset()
        return
      }

      const savedCount = result.data.savedCount || 0
      const duplicateCount = params.screenNames.length - savedCount

      this.$notify({
        title: `${savedCount}件のNGアカウント(重複${duplicateCount}件)を追加しました。`,
        message: '',
        customClass: 'success',
        duration: 5000
      })
      this.reset()

      const { shouldLeaveGroupSetting } = await this.fetchNgApplicants(this.snsType)

      if (shouldLeaveGroupSetting) {
        this.$router.push('/campaigns')
      }
    },

    /**
     * Set params
     * @returns {{ groupId: number | undefined, screenNames: string[] }}
     */
    setParams(): { groupId: number | undefined; screenNames: string[] } {
      return {
        groupId: this.currentGroup?.id,
        screenNames: this.screenNames
          .replace(/^\s*[\r\n]/gm, '')
          .replace(/^\s+|\s+$/g, '')
          .replace(/ /g, '')
          .replace(/@/g, '')
          .split('\n')
      }
    },

    /**
     * Reset data
     */
    reset() {
      this.screenNames = ''
      this.visible = false
    },

    /**
     * Reset data before close
     */
    beforeClose() {
      if (!this.isFormChanged) {
        return this.reset()
      }

      const message = '編集内容が保存されていません。ダイアログを閉じてよろしいですか?'
      const confirm = window.confirm(message)

      if (confirm) {
        return this.reset()
      }
    }
  },
  validations: {
    screenNames: {
      required
    }
  }
})
</script>
